import apiClient from "../lib/utils/network-client";

export async function getGalleryItems({ page = 1, limit = 10 } = {}) {
  try {
    const response = await apiClient.get("/gallery", {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      message: error.message || "Failed to fetch gallery items"
    };
  }
}

export async function createGalleryItem(data) {
  try {
    const response = await apiClient.post("/gallery", data);
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      message: error.message || "Failed to create gallery item"
    };
  }
}

export async function updateGalleryItem(id, data) {
  try {
    const response = await apiClient.put(`/gallery/${id}`, data);
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      message: error.message || "Failed to update gallery item"
    };
  }
}

export async function deleteGalleryItem(id) {
  try {
    const response = await apiClient.delete(`/gallery/${id}`);
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      return error.response.data;
    }
    return {
      success: false,
      message: error.message || "Failed to delete gallery item"
    };
  }
}
